
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chapterId]",
      function () {
        return require("private-next-pages/[chapterId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[chapterId]"])
      });
    }
  